// Component overrides for MUI theme
// Customizes default MUI component styles
import { palette as defaultPalette } from './palette'

export const createComponents = palette => ({
  // Button component customization
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 500,
        transition: 'all 300ms ease',
        '&:hover': {
          transform: 'translateY(-1px)',
        },
      },
      sizeMedium: {
        height: '44px',
      },
      sizeLarge: {
        height: '52px',
      },
      contained: {
        boxShadow:
          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        '&:hover': {
          boxShadow:
            '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      sizeMedium: {
        width: '48px',
        height: '48px',
      },
    },
  },
  MuiFab: {
    styleOverrides: {
      sizeMedium: {
        width: '48px',
        height: '48px',
      },
    },
  },

  // Mui DatePicker component customization
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        backgroundColor: palette.primary.main,
        color: '#fff',
        borderRadius: '8px',
      },
      viewTransitionContainer: {
        color: 'black',
        background: 'white',
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      root: {
        marginTop: '8px',
        marginBottom: '8px',
      },
      switchViewButton: {
        color: 'white',
      },
    },
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      button: {
        color: 'white',
      },
    },
  },

  // Input components customization
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: '14px',
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: '0.5rem',
          transition: 'all 300ms ease',
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: palette.primary.main,
            },
          },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: '2px',
            },
          },
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        height: '0.35rem',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        height: '44px',
      },
      sizeSmall: {
        height: '36px',
      },
      multiline: {
        height: 'auto',
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      inputRoot: {
        paddingTop: 0,
        paddingBottom: 0,
        alignItems: 'center',
      },
      input: {
        padding: '0 0.875rem !important',
        height: '44px !important',
        minHeight: '44px !important',
        boxSizing: 'border-box',
      },
    },
  },

  // Paper component customization
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        background: '#FFF',
        border: '1px solid #DDDFE8',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
      },
    },
  },

  // Card component customization
  MuiCard: {
    styleOverrides: {
      root: {
        border: 'none',
        boxShadow: '0px 4px 15px 0px #4047761A, 0px 8px 4px 0px #DDDFE840',
      },
    },
  },

  // Menu & Listcomponent customization
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: '6px',
        boxShadow:
          '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        marginTop: '2px',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        margin: '2px 0',
        padding: '3px 9px',
        borderRadius: '6px',
      },
    },
  },
  MuiList: {
    styleOverrides: {
      root: {
        padding: '8px',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
      },
    },
  },

  // Tab component customization
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 500,
        transition: 'all 300ms ease',
      },
    },
  },

  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '10px',
      },
    },
  },

  // // AppBar component customization
  // MuiAppBar: {
  //   styleOverrides: {
  //     root: {
  //       // boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  //       // backdropFilter: 'blur(8px)',
  //     },
  //   },
  // },
})

// Backward-compatible static export using default palette
export const components = createComponents(defaultPalette)
